import crypto from 'crypto-js'

export class LockPage{

  constructor() {
    var unlockSubmit = document.getElementById('unlockSubmit');
    if(unlockSubmit){
      unlockSubmit.addEventListener('click',this.check.bind(this));  
    }
    
  }
  
  check(e){
    e.preventDefault();
    
    var inputName = document.getElementById('unlockName').value;
    var inputPassword = document.getElementById('unlockPassword').value;

    inputName = crypto.SHA256(inputName).toString();
    inputPassword = crypto.SHA256(inputPassword).toString(); 

    if(UNLOCK_NAME == inputName && UNLOCK_PASSWORD == inputPassword){
      document.getElementById('page').classList.remove('is-lock');
    }else{
      alert('閲覧ID/パスワードが間違っています。');
    }
  }
  

}